import { apiSendFormData } from '@/lib/api/client';
import type { AnimationMediaMode } from '@/mocks/siteContent';

interface UploadedContentMedia {
  url: string;
  type: Exclude<AnimationMediaMode, 'animation'>;
}

export async function uploadContentMedia(file: File) {
  const formData = new FormData();
  formData.append('media', file);
  return apiSendFormData<UploadedContentMedia>('/admin/content-media.php', 'POST', formData);
}

export async function uploadAnimationMedia(file: File) {
  return uploadContentMedia(file);
}
